// see https://github.com/mui-org/material-ui/issues/13744

import { StandardProps } from '@material-ui/core';
import OrgFormLabel from '@material-ui/core/FormLabel';
import * as React from 'react';

export interface IFormLabelProps
	extends StandardProps<FormLabelBaseProps, FormLabelClassKey> {
	component?: React.ReactType<FormLabelBaseProps> | 'legend';
	disabled?: boolean;
	error?: boolean;
	filled?: boolean;
	focused?: boolean;
	required?: boolean;
}

export type FormLabelBaseProps = React.LabelHTMLAttributes<HTMLLabelElement>;

export type FormLabelClassKey =
	| 'root'
	| 'focused'
	| 'disabled'
	| 'error'
	| 'filled'
	| 'required'
	| 'asterisk';

const FormLabel: React.FC<IFormLabelProps> = props => (
	<OrgFormLabel {...props as any} />
);

export default FormLabel;



// WEBPACK FOOTER //
// ./src/utils/FormLabelWrapper.tsx